// Mirrors Sippy-server/config/constants.js — the API rejects any category
// outside this list, so the two must be changed together.
export const NEWS_CATEGORIES = [
  "EVENTS",
  "THEATRICAL RELEASE",
  "PRODUCTION",
  "LEGACY",
  "CORPORATE",
  "COMPANY NEWS",
];

// How many news items the admin list pulls per request.
export const NEWS_PAGE_SIZE = 50;

// The API returns dates as ISO timestamps; <input type="date"> needs YYYY-MM-DD.
export function toDateInput(value) {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

// ...and readers need something better than a raw timestamp.
export function formatNewsDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
